import { useState } from "react";
import Slider from '../../../components/Slider'

export default function Security() {
    const [enabled, setEnabled] = useState(false);

    return (
        <div className="w-72">
            <div className="flex items-center justify-between mb-2">
                <span className="font-semibold">
                    Two-factor authentication
                </span>
                <Slider isToggled={false} />
            </div>

            <button className="text-sm font-medium text-gray-500 underline mt-1">
                Set up
            </button>
        </div>
    );
}
